import { render } from "./act-set-access-periods.vue?vue&type=template&id=eb330d96&ts=true"
import script from "./act-set-access-periods.ts?vue&type=script&lang=ts&external"
export * from "./act-set-access-periods.ts?vue&type=script&lang=ts&external"

import "./act-set-access-periods.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__